export const hasWebGL = () => {
  try {
    const canvas = document.createElement('canvas')
    const result = !!(
      window.WebGLRenderingContext &&
      (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
    )
    canvas.remove()
    return result
  } catch (_e) {
    return false
  }
}
